import { createFeatureSelector } from '@ngrx/store';
import { createApiCallSelectors } from '../../../../common/store/generic.selectors';
import { WorkLocationModel, workLocationFeatureKey } from './types';
import { IWorkLocationState } from './work-location.reducer';

const workLocationFeatureState = createFeatureSelector<IWorkLocationState>(
  workLocationFeatureKey,
);

export const workLocationSelectors = {
  getById: createApiCallSelectors<WorkLocationModel, IWorkLocationState>(
    workLocationFeatureState,
    'getById',
  ),
  createInstance: createApiCallSelectors<WorkLocationModel, IWorkLocationState>(
    workLocationFeatureState,
    'createInstance',
  ),
  add: createApiCallSelectors<WorkLocationModel, IWorkLocationState>(
    workLocationFeatureState,
    'add',
  ),
  update: createApiCallSelectors<WorkLocationModel, IWorkLocationState>(
    workLocationFeatureState,
    'update',
  ),
  delete: createApiCallSelectors<boolean, IWorkLocationState>(
    workLocationFeatureState,
    'delete',
  ),
};
